import { Component, ViewChild } from '@angular/core';
import { ChampsFusion } from '@core/models/champsFusion.model';
import { GlobalDataService } from '@core/services';
import { isPaveAdresseField } from '@core/utils/champs-fusion.utils';
import { MdePopoverTrigger } from '@material-extended/mde';

@Component({
  selector: 'app-suivi-campagne-recapilatif',
  templateUrl: './suivi-campagne-recapilatif.component.html',
  styleUrls: ['./suivi-campagne-recapilatif.component.scss']
})
export class SuiviCampagneRecapilatifComponent {

  @ViewChild(MdePopoverTrigger) trigger: MdePopoverTrigger;

  get PersonalisationChampsFusion(): ChampsFusion[] {
    return (this._GlobalDataService.CampagneExt?.ChampsFusion || [])
      .filter(cf => !isPaveAdresseField(cf));
  }

  get AdressesDestinatairesChampsFusion(): ChampsFusion[] {
    return (this._GlobalDataService.CampagneExt?.ChampsFusion || [])
      .filter(isPaveAdresseField);
  }

  constructor(
    public _GlobalDataService: GlobalDataService,
  ) { }
}
